// 商品描述 + 推荐商品

import React, { useState } from 'react';

import RecomendProductCard from '../../conponents/RecomendCard';
import ProductRateComp, { TAB_TYPE } from '../../conponents/ProductRate';

import useRecommendProductClick from './useRecommendProductClick';
import type { IProductDetail, IPriceConfig } from '../../product';
import type { TabsType } from '../../conponents/ProductRate';

type Props = {
  productDetail: IProductDetail;
  priceConfig: IPriceConfig;
};

export function ProductDescriptWithRecommend({ productDetail, priceConfig }: Props) {
  const { concreteFlag } = productDetail;
  const [currentTab, setCurrentTab] = useState<TabsType>(
    concreteFlag ? TAB_TYPE.DETAIL : TAB_TYPE.QUICK_LIST,
  );
  const { currentSelectedRecommendProduct, onRecommendProductClick } = useRecommendProductClick({
    onRecommendConfirm: () => {
      // 确认则进入「推荐清单」
      setCurrentTab(TAB_TYPE.RECOMMEND_QUICK);
    },
  });

  const handleTabChange = (tab) => {
    setCurrentTab(tab);
  };

  return (
    <>
      <RecomendProductCard
        recomendProduct={productDetail?.recommendSpuDTO?.recommendSpuList || []}
        priceConfig={priceConfig}
        onRecommendProductClick={onRecommendProductClick}
      />
      <ProductRateComp
        currentTab={currentTab}
        onTabChange={handleTabChange}
        currentSelectedRecommendProduct={currentSelectedRecommendProduct}
        evaluateObjectSysNo={productDetail?.supplierSysNo}
        detailContentOfHtml={productDetail?.detailContentOfHtml}
        productDetail={productDetail}
      />
    </>
  );
}

// export default forwardRef(ProductDescriptWithRecommend);
